/**
 * Payout Statuses
 */
const CREATED = 'CREATED'
const CANCELED = 'CANCELED'
const PENDING = 'PENDING'
const UNCLAIMED = 'UNCLAIMED'
const SUCCESS = 'SUCCESS'

const BLOCKED = 'BLOCKED'
const DENIED = 'DENIED'
const FAILED = 'FAILED'
const ONHOLD = 'ONHOLD'
const PROCESSING = 'PROCESSING'
const REFUNDED = 'REFUNDED'
const RETURNED = 'RETURNED'
const REVERSED = 'REVERSED'
const SUCCEEDED = 'SUCCEEDED'
const STAFF_CANCELED = 'STAFF_CANCELED'

const PAYOUT_STATUS_CHOICES = [
  {
    value: CREATED,
    label: 'Created',
  },
  {
    value: CANCELED,
    label: 'Cancelled',
  },
  {
    value: PENDING,
    label: 'Pending',
  },
  {
    value: UNCLAIMED,
    label: 'Unclaimed',
  },
  {
    value: SUCCESS,
    label: 'Success',
  },
  {
    value: BLOCKED,
    label: 'Blocked',
  },
  {
    value: DENIED,
    label: 'Denied',
  },
  {
    value: FAILED,
    label: 'Failed',
  },
  {
    value: ONHOLD,
    label: 'On hold',
  },
  {
    value: PROCESSING,
    label: 'Processing',
  },
  {
    value: REFUNDED,
    label: 'Refunded',
  },
  {
    value: RETURNED,
    label: 'Returned',
  },
  {
    value: REVERSED,
    label: 'Reversed',
  },
  {
    value: SUCCEEDED,
    label: 'Succeeded',
  },
  {
    value: STAFF_CANCELED,
    label: 'Staff canceled',
  },
]

export default {
  CREATED,
  CANCELED,
  PENDING,
  UNCLAIMED,
  SUCCESS,
  BLOCKED,
  DENIED,
  FAILED,
  ONHOLD,
  PROCESSING,
  REFUNDED,
  RETURNED,
  REVERSED,
  SUCCEEDED,
  STAFF_CANCELED,
  PAYOUT_STATUS_CHOICES,
}
